import React, { lazy, Suspense } from 'react';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { Loading } from 'react-admin';

// Lazily import the components
const AuthorizedSupplierList = lazy(() => import('./AuthorizedSupplierList'));
const AuthorizedSupplierCreate = lazy(() => import('./AuthorizedSupplierCreate'));
const AuthorizedSupplierEdit = lazy(() => import('./AuthorizedSupplierEdit'));

// Define a component to handle the loading fallback
const Loader = () => <Loading />;

// Define the config with Suspense wrappers
const config = {
  list: () => (
    <Suspense fallback={<Loader />}>
      <AuthorizedSupplierList />
    </Suspense>
  ),
  create: () => (
    <Suspense fallback={<Loader />}>
      <AuthorizedSupplierCreate />
    </Suspense>
  ),
  edit: () => (
    <Suspense fallback={<Loader />}>
      <AuthorizedSupplierEdit />
    </Suspense>
  ),
  icon: <LockOpenIcon />
};

export default config;
